export default __webpack_public_path__ + "static/media/cesto_mele.09278e81.svg";